import { cn } from "@/engine/support/classNames";

export interface AppAvatar {
  emoji: string;
  color: string;
}

/**
 * The frame a wide screen outside a room is drawn in: the thing itself, and
 * sometimes a list beside it.
 *
 * The room somebody was invited to and the screen where one is opened are this
 * shape, so they are one component rather than two arrangements of the same
 * idea, and crossing between them does not change it. There is no rail (#738):
 * home is one page, and its rooms are on it. A room is not drawn in this frame
 * either — it is its own, with the people column on its left edge.
 *
 * It fills the window, and the middle scrolls on its own so the list beside it
 * stays put.
 */
export function AppShell({
  aside,
  testId = "app-shell",
  children,
}: {
  aside?: React.ReactNode;
  /** Which of the wide screens this is, for the tests that tell them apart. */
  testId?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      data-testid={testId}
      className={cn(
        // Both: `flex-1` where a flex column holds it, `h-full` where the
        // screen handover's absolutely positioned box does.
        "flex h-full min-h-0 w-full flex-1 items-stretch overflow-hidden",
      )}
    >
      <div className="min-w-0 flex-1 overflow-y-auto px-4 py-4 sm:px-6">
        {/* The page inside keeps the arithmetic the four room-type cards
            need: 1040 of content, centred in whatever is left over. */}
        <div className="mx-auto w-full max-w-[65rem]">{children}</div>
      </div>
      {aside}
    </div>
  );
}
